// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root__CM7u7","ribbon":"CustomButton_ribbon__73wSs"};